export default "__VITE_ASSET__1awsWnpC__"